/* Kieszonkowe Inc. — tło wideo w hero: krótkie klipy ludzi w koszulkach marki.
   Kolejność: najpierw co najmniej 2 klipy ze sceny „szkola” (jeśli są), potem reszta losowo, w pętli.
   Start dopiero po załadowaniu strony (nie konkuruje z LCP); wyłączone przy prefers-reduced-motion i Save-Data. */
(function (root) {
  'use strict';

  function shuffle(list, rand) {
    const a = list.slice();
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(rand() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  }

  /** Kolejność odtwarzania: minSchool klipów „szkola” na początku, potem pozostałe (losowo). */
  function orderClips(clips, rand, minSchool) {
    rand = rand || Math.random;
    minSchool = minSchool == null ? 2 : minSchool;
    const school = shuffle(clips.filter((c) => c.scene === 'szkola'), rand);
    const head = school.slice(0, minSchool);
    const rest = shuffle(clips.filter((c) => head.indexOf(c) === -1), rand);
    return head.concat(rest);
  }

  function start(el) {
    let clips;
    try { clips = JSON.parse(el.querySelector('script[type="application/json"]').textContent); } catch (e) { return; }
    clips = clips.filter((c) => c && c.src);
    if (!clips.length) return;
    const reduce = root.matchMedia && root.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const saveData = root.navigator && root.navigator.connection && root.navigator.connection.saveData;
    if (reduce || saveData) return;

    const order = orderClips(clips);
    const videos = Array.from(el.querySelectorAll('video'));
    let idx = 0, active = 0, timer;

    function show(i, slot) {
      const clip = order[i % order.length];
      const v = videos[slot];
      v.src = clip.src;
      if (clip.label) v.setAttribute('aria-label', clip.label);
      const p = v.play();
      if (p && p.catch) p.catch(() => {});
      v.classList.add('is-active');
      videos[1 - slot].classList.remove('is-active');
      clearTimeout(timer);
      timer = setTimeout(next, Math.max(2, Math.min(12, clip.seconds || 5)) * 1000);
    }
    function next() {
      idx += 1;
      active = 1 - active;
      show(idx, active);
      const old = videos[1 - active];
      setTimeout(() => { old.pause(); }, 700);
    }
    el.classList.add('is-playing');
    show(0, 0);
    document.addEventListener('visibilitychange', () => {
      const v = videos[active];
      if (document.hidden) { v.pause(); clearTimeout(timer); } else { v.play().catch(() => {}); timer = setTimeout(next, 4000); }
    });
  }

  if (typeof module !== 'undefined' && module.exports) { module.exports = { orderClips: orderClips }; return; }
  /** Hero wsuwa się pod półprzezroczysty pasek menu: --k-header-h = aktualna wysokość nagłówka. */
  function trackHeader() {
    const header = document.querySelector('.section-header');
    if (!header) return;
    const set = () => document.documentElement.style.setProperty('--k-header-h', header.offsetHeight + 'px');
    set();
    if (root.ResizeObserver) new ResizeObserver(set).observe(header); else root.addEventListener('resize', set);
  }
  const boot = () => { trackHeader(); document.querySelectorAll('[data-k-hero-video]').forEach(start); };
  if (document.readyState === 'complete') boot(); else root.addEventListener('load', boot);
})(typeof window !== 'undefined' ? window : globalThis);
